import { CustomFieldStatusType } from 'gql';

export const CustomFieldStatusToStatus: Record<CustomFieldStatusType, 'active' | 'inactive'> = {
  [CustomFieldStatusType.Active]: 'active',
  [CustomFieldStatusType.Inactive]: 'inactive',
};